import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router, ActivatedRoute } from '@angular/router';
@Injectable()
export class AuthService {
  constructor(public jwtHelper: JwtHelperService, private router: Router) {}
  // ...
  // public isAuthenticated(): boolean {
  //   const token = localStorage.getItem('currentUser');
  //   return !this.jwtHelper.isTokenExpired(token);
  // }


  isAuthenticated() {
    const user = localStorage.getItem('currentUser');

    return user != null && user.length > 0;

  }
}
